import React, { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "@mui/material";
import { responsiveFontSize } from "@common/components/Typography/style";
import { LineChartInstance } from "../../types";

type ZoomButtonProps = {
  type: "zoomIn" | "zoomOut";
  chartRef: RefObject<LineChartInstance | null>;
};

const ZOOM_FACTOR = {
  zoomIn: 1.2,
  zoomOut: 2 - 1 / 0.8,
};

const ZoomButton = ({ type, chartRef }: ZoomButtonProps) => {
  const { t } = useTranslation();

  const isZoomInType = type === "zoomIn";
  const translationKey = isZoomInType ? "Zoom In" : "Zoom Out";
  const label = t(translationKey);
  const zoomHint = t("Hold ctrl to zoom in/out by scrolling");

  const handleClick = () => {
    const zoomStep = ZOOM_FACTOR[type];

    chartRef.current?.zoom(zoomStep);
  };

  return (
    <Tooltip arrow title={zoomHint}>
      <Button
        onClick={handleClick}
        sx={(theme) => responsiveFontSize(theme, "medium")}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default ZoomButton;
